import React, { ReactNode } from 'react';
import cn from 'classnames';
import { InfoIcon } from '../../icons';
import styles from './label.module.scss';
import text from './label.text.json';
import { TextFieldProps } from '../main';
import noop from 'lodash/noop';

export const VARIANTS = ['regular', 'info', 'optional'] as const;

export type Variant = (typeof VARIANTS)[number];

export type LabelProps = {
  name: string;
  label?: string | ReactNode;
  variant: Variant;
  disabled?: boolean;
  flexedStyle?: boolean;
  onClick?: TextFieldProps['onClick'];
};

export const Label: React.VFC<LabelProps> = ({
  name,
  label,
  variant,
  disabled,
  flexedStyle = true,
  onClick = noop,
}) => {
  const isInfoVariants = variant === VARIANTS[1];
  const isOptionalVariant = variant === VARIANTS[2];
  return (
    <label
      htmlFor={name}
      data-testid="label-text-field"
      onClick={onClick}
      className={cn(
        styles.label,
        flexedStyle && styles.flexed,
        disabled && styles.disabled,
      )}
    >
      {label}
      {isInfoVariants && (
        <InfoIcon className={styles['info-icon']} data-testid="info-icon" />
      )}
      {isOptionalVariant && (
        <span className={styles['optional-label']} data-testid="optional-icon">
          ({text.OPTIONAL})
        </span>
      )}
    </label>
  );
};
